// /home/clement/compta-app/client/src/components/Stocks/AlertesStock.js

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

const AlertesStock = () => {
  const [alertes, setAlertes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [currentAlerte, setCurrentAlerte] = useState(null);

  useEffect(() => {
    const fetchAlertesStock = async () => {
      try {
        const response = await axios.get("/api/alertes-stock");
        setAlertes(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAlertesStock();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleEdit = (alerte) => {
    setCurrentAlerte(alerte);
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      await axios.put(`/api/alertes-stock/${currentAlerte.id}`, currentAlerte);
      const response = await axios.get("/api/alertes-stock");
      setAlertes(response.data);
      handleClose();
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <Alert severity="error" style={{ marginTop: "20px" }}>
        Erreur lors de la récupération des alertes de stock : {error}
      </Alert>
    );
  }

  return (
    <div className="alertes-stock">
      <h2>Alertes de Stock</h2>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Produit</TableCell>
              <TableCell>Seuil Min</TableCell>
              <TableCell>Seuil Max</TableCell>
              <TableCell>Actif</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alertes.map((alerte) => (
              <TableRow key={alerte.id}>
                <TableCell>{alerte.id}</TableCell>
                <TableCell>{alerte.ProduitService?.nom || "N/A"}</TableCell>
                <TableCell>{alerte.seuil_min}</TableCell>
                <TableCell>{alerte.seuil_max}</TableCell>
                <TableCell>{alerte.actif ? "Oui" : "Non"}</TableCell>
                <TableCell>
                  <Button variant="contained" color="primary" onClick={() => handleEdit(alerte)}>
                    Modifier
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Modifier l'alerte</DialogTitle>
        <DialogContent>
          {currentAlerte && (
            <div>
              <TextField
                margin="dense"
                label="Seuil Min"
                type="number"
                fullWidth
                value={currentAlerte.seuil_min}
                onChange={(e) => setCurrentAlerte({ ...currentAlerte, seuil_min: e.target.value })}
              />
              <TextField
                margin="dense"
                label="Seuil Max"
                type="number"
                fullWidth
                value={currentAlerte.seuil_max}
                onChange={(e) => setCurrentAlerte({ ...currentAlerte, seuil_max: e.target.value })}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Annuler
          </Button>
          <Button onClick={handleSave} color="primary">
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertesStock;
